import { render, staticRenderFns } from "./ModalLogsPrestadorRecebimento.vue?vue&type=template&id=a690bd70&scoped=true"
import script from "./ModalLogsPrestadorRecebimento.vue?vue&type=script&lang=ts"
export * from "./ModalLogsPrestadorRecebimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalLogsPrestadorRecebimento.vue?vue&type=style&index=0&id=a690bd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a690bd70",
  null
  
)

export default component.exports